import { render, staticRenderFns } from "./listado_pedidos2.vue?vue&type=template&id=c195feac&scoped=true"
import script from "./listado_pedidos2.vue?vue&type=script&lang=js"
export * from "./listado_pedidos2.vue?vue&type=script&lang=js"
import style0 from "./listado_pedidos2.vue?vue&type=style&index=0&id=c195feac&prod&lang=scss&scoped=true"
import style1 from "./listado_pedidos2.vue?vue&type=style&index=1&id=c195feac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c195feac",
  null
  
)

export default component.exports